<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1240 558" style="enable-background:new 0 0 1240 558;" xml:space="preserve">
<g id="FILL">
	<g>
		<polygon id="G05" class="svg-floorplate" points="705.67,161.28 705.67,155.44 705.67,135.94 652.85,135.94 652.85,155.44 590.27,155.44
			590.27,263.53 705.67,263.53 		"/>
		<polygon id="G04" class="svg-floorplate" points="817.01,161.28 817.01,155.44 817.01,135.94 765.81,135.94 765.81,155.44 705.67,155.44
			705.67,263.53 817.01,263.53 		"/>
		<polygon id="G03" class="svg-floorplate" points="933.22,161.26 933.22,155.43 933.22,135.93 877.96,135.93 877.96,155.43 817.01,155.43
			817.01,263.52 933.22,263.52 		"/>
		<polygon id="A1" class="svg-floorplate" points="756.06,407.38 817.01,407.38 817.01,292.79 753.62,292.79 753.62,345.61
			590.27,345.61 590.27,427.69 756.06,427.69 		"/>
		<polygon id="A2" class="svg-floorplate" points="933.22,292.79 817.01,292.79 817.01,407.37 872.27,407.37 872.27,422.82 933.22,422.82
					"/>

    <router-link :to="{ name: 'apartment', params: {apartment:  103}}">
			<polygon id="A3" class="svg-transparent" points="1103.88,440.72 1103.88,370.02 1068.94,370.02 1068.94,292.81 933.22,292.81
				933.22,425.28 956.79,425.28 956.79,440.72 		"/>
    </router-link>
		<router-link :to="{ name: 'apartment', params: {apartment:  104}}">
		<polygon id="A4" class="svg-transparent" points="1068.94,113.24 1068.94,185.57 1103.89,185.57 1103.89,257.08 1068.94,263.58
			933.22,263.58 933.22,128.68 956.79,128.68 956.79,113.24 		"/>
		</router-link>
		<polygon id="A5" class="svg-floorplate" points="590.27,132.69 540.7,132.69 540.7,150.57 483,150.57 483,263.53 590.27,263.53 		"/>
		<polygon id="A6" class="svg-floorplate" points="483,132.69 426.92,132.69 426.92,150.57 368.41,150.57 368.41,263.53 483,263.53 		"/>
		<polygon id="A7" class="svg-floorplate" points="368.41,132.69 318.84,132.69 318.84,150.57 255.45,150.57 255.45,263.53 368.41,263.53
					"/>
		<polygon id="A8" class="svg-floorplate" points="192.06,152.99 255.45,152.99 255.45,263.52 123.79,263.52 123.79,235.07 139.23,235.07
			139.23,211.51 123.79,211.51 123.79,115.61 192.06,115.61 		"/>
		<polygon id="A9" class="svg-floorplate" points="192.06,403.3 255.45,403.3 255.45,292.77 123.79,292.77 123.79,320.4 139.23,320.4
			139.23,345.6 123.79,345.6 123.79,440.68 192.06,440.68 		"/>
		<polygon id="A10" class="svg-floorplate" points="425.3,420.36 425.3,292.77 255.45,292.77 255.45,390.29 305.02,390.29 305.02,420.36
			"/>
		<polygon id="A11" class="svg-floorplate" points="545.57,397.61 590.27,397.61 590.27,292.77 425.3,292.77 425.3,420.36 545.57,420.36
			"/>
	</g>
</g>
<g id="STROKES">
	<line class="st2" x1="123.79" y1="345.61" x2="123.79" y2="440.7"/>
	<line class="st2" x1="1068.94" y1="369.99" x2="1103.88" y2="369.99"/>
	<line class="st2" x1="1068.94" y1="292.79" x2="1068.94" y2="369.99"/>
	<line class="st2" x1="1068.94" y1="185.51" x2="1103.88" y2="185.51"/>
	<line class="st2" x1="1068.94" y1="113.19" x2="1068.94" y2="185.51"/>
	<line class="st2" x1="956.79" y1="425.25" x2="933.22" y2="425.25"/>
	<line class="st2" x1="956.79" y1="440.7" x2="956.79" y2="425.25"/>
	<line class="st2" x1="1103.88" y1="440.7" x2="956.79" y2="440.7"/>
	<line class="st2" x1="1103.88" y1="299.29" x2="1103.88" y2="440.7"/>
	<line class="st2" x1="1068.94" y1="292.79" x2="1103.88" y2="299.29"/>
	<line class="st2" x1="1068.94" y1="263.53" x2="1068.94" y2="292.79"/>
	<line class="st2" x1="1103.88" y1="257.03" x2="1068.94" y2="263.53"/>
	<line class="st2" x1="1103.88" y1="113.19" x2="1103.88" y2="257.03"/>
	<line class="st2" x1="956.79" y1="113.19" x2="1103.88" y2="113.19"/>
	<line class="st2" x1="956.79" y1="128.63" x2="956.79" y2="113.19"/>
	<line class="st2" x1="933.22" y1="128.63" x2="956.79" y2="128.63"/>
	<line class="st2" x1="877.96" y1="135.94" x2="933.22" y2="135.94"/>
	<line class="st2" x1="877.96" y1="155.45" x2="877.96" y2="135.94"/>
	<line class="st2" x1="817.01" y1="155.45" x2="877.96" y2="155.45"/>
	<line class="st2" x1="765.81" y1="135.94" x2="817.01" y2="135.94"/>
	<line class="st2" x1="765.81" y1="155.45" x2="765.81" y2="135.94"/>
	<line class="st2" x1="705.67" y1="155.45" x2="765.81" y2="155.45"/>
	<line class="st2" x1="652.85" y1="135.94" x2="705.67" y2="135.94"/>
	<line class="st2" x1="652.85" y1="155.45" x2="652.85" y2="135.94"/>
	<line class="st2" x1="590.27" y1="155.45" x2="652.85" y2="155.45"/>
	<line class="st2" x1="368.41" y1="120.5" x2="368.41" y2="263.53"/>
	<line class="st2" x1="318.84" y1="132.69" x2="368.41" y2="132.69"/>
	<line class="st2" x1="318.84" y1="150.57" x2="318.84" y2="132.69"/>
	<line class="st2" x1="255.45" y1="150.57" x2="318.84" y2="150.57"/>
	<line class="st2" x1="426.92" y1="132.69" x2="483" y2="132.69"/>
	<line class="st2" x1="426.92" y1="150.57" x2="426.92" y2="132.69"/>
	<line class="st2" x1="368.41" y1="150.57" x2="426.92" y2="150.57"/>
	<line class="st2" x1="483" y1="263.53" x2="483" y2="120.5"/>
	<line class="st2" x1="540.7" y1="132.69" x2="590.27" y2="132.69"/>
	<line class="st2" x1="540.7" y1="150.57" x2="540.7" y2="132.69"/>
	<line class="st2" x1="545.57" y1="397.62" x2="545.57" y2="420.38"/>
	<line class="st2" x1="590.27" y1="397.62" x2="545.57" y2="397.62"/>
	<line class="st2" x1="872.27" y1="422.82" x2="933.22" y2="422.82"/>
	<line class="st2" x1="933.22" y1="292.79" x2="933.22" y2="422.82"/>
	<line class="st2" x1="139.23" y1="345.61" x2="123.79" y2="345.61"/>
	<line class="st2" x1="139.23" y1="320.42" x2="139.23" y2="345.61"/>
	<line class="st2" x1="123.79" y1="320.42" x2="139.23" y2="320.42"/>
	<line class="st2" x1="139.23" y1="263.53" x2="139.23" y2="292.79"/>
	<line class="st2" x1="425.3" y1="420.38" x2="545.57" y2="420.38"/>
	<line class="st2" x1="305.02" y1="390.31" x2="255.45" y2="390.31"/>
	<line class="st2" x1="305.02" y1="420.38" x2="305.02" y2="390.31"/>
	<line class="st2" x1="425.3" y1="420.38" x2="305.02" y2="420.38"/>
	<line class="st2" x1="255.45" y1="292.79" x2="255.45" y2="440.7"/>
	<line class="st2" x1="192.06" y1="403.31" x2="255.45" y2="403.31"/>
	<line class="st2" x1="192.06" y1="440.7" x2="192.06" y2="403.31"/>
	<line class="st2" x1="123.79" y1="440.7" x2="933.22" y2="440.7"/>
	<line class="st2" x1="123.79" y1="292.79" x2="123.79" y2="320.42"/>
	<line class="st2" x1="590.27" y1="292.79" x2="123.79" y2="292.79"/>
	<line class="st2" x1="425.3" y1="440.7" x2="425.3" y2="292.79"/>
	<line class="st2" x1="483" y1="150.57" x2="540.7" y2="150.57"/>
	<line class="st2" x1="255.45" y1="120.5" x2="255.45" y2="263.53"/>
	<line class="st2" x1="192.06" y1="153.01" x2="255.45" y2="153.01"/>
	<line class="st2" x1="192.06" y1="115.62" x2="192.06" y2="153.01"/>
	<line class="st2" x1="123.79" y1="115.62" x2="192.06" y2="115.62"/>
	<line class="st2" x1="123.79" y1="211.52" x2="123.79" y2="115.62"/>
	<line class="st2" x1="139.23" y1="211.52" x2="123.79" y2="211.52"/>
	<line class="st2" x1="139.23" y1="235.09" x2="139.23" y2="211.52"/>
	<line class="st2" x1="123.79" y1="235.09" x2="139.23" y2="235.09"/>
	<line class="st2" x1="123.79" y1="263.53" x2="123.79" y2="235.09"/>
	<line class="st2" x1="817.01" y1="263.53" x2="817.01" y2="120.5"/>
	<line class="st2" x1="705.67" y1="263.53" x2="705.67" y2="120.5"/>
	<line class="st2" x1="817.01" y1="440.7" x2="817.01" y2="292.79"/>
	<line class="st2" x1="933.22" y1="440.7" x2="933.22" y2="422.82"/>
	<line class="st2" x1="590.27" y1="120.5" x2="590.27" y2="146.51"/>
	<line class="st2" x1="933.22" y1="120.5" x2="192.06" y2="120.5"/>
	<line class="st2" x1="590.27" y1="263.53" x2="590.27" y2="146.51"/>
	<line class="st2" x1="1068.94" y1="263.53" x2="123.79" y2="263.53"/>
	<line class="st2" x1="753.62" y1="292.79" x2="1068.94" y2="292.79"/>
	<line class="st2" x1="753.62" y1="345.61" x2="590.27" y2="345.61"/>
	<line class="st2" x1="753.62" y1="292.79" x2="753.62" y2="345.61"/>
	<line class="st2" x1="590.27" y1="301.73" x2="753.62" y2="301.73"/>
	<line class="st2" x1="590.27" y1="440.7" x2="590.27" y2="292.79"/>
	<line class="st2" x1="756.06" y1="427.69" x2="590.27" y2="427.69"/>
	<line class="st2" x1="756.06" y1="407.38" x2="756.06" y2="427.69"/>
	<line class="st2" x1="872.27" y1="407.38" x2="756.06" y2="407.38"/>
	<line class="st2" x1="872.27" y1="422.82" x2="872.27" y2="407.38"/>
	<line class="st2" x1="933.22" y1="120.5" x2="933.22" y2="263.53"/>
	<line class="st2" x1="872.27" y1="407.38" x2="872.27" y2="422.82"/>
	<line class="st2" x1="872.27" y1="422.82" x2="933.22" y2="422.82"/>
	<line class="st2" x1="933.22" y1="422.82" x2="933.22" y2="292.79"/>
	<line class="st2" x1="933.22" y1="292.79" x2="817.01" y2="292.79"/>
	<line class="st2" x1="817.01" y1="292.79" x2="817.01" y2="407.38"/>
	<line class="st2" x1="817.01" y1="407.38" x2="872.27" y2="407.38"/>
</g>
<g id="KEY_FRAME">
	<polygon class="st3" points="139.23,263.53 123.79,263.53 123.79,235.09 139.23,235.09 139.23,211.52 123.79,211.52 123.79,115.62
		192.06,115.62 192.06,120.5 933.22,120.5 933.22,128.63 956.79,128.63 956.79,113.19 1103.88,113.19 1103.88,257.03
		1068.94,263.53 1068.94,292.79 1103.88,299.29 1103.88,440.7 956.79,440.7 956.79,425.25 933.22,425.25 933.22,440.7 123.79,440.7
		123.79,345.61 139.23,345.61 139.23,320.42 123.79,320.42 123.79,292.79 139.23,292.79 	"/>
</g>
</svg>

</template>

<script>
export default {

}
</script>

<style>
  	.svg-floorplate{fill:#B85345; }
	.svg-floorplate{fill:#B85345;}
	.svg-transparent { fill: rgba(255, 158, 44, .5) }
	.st2{fill:none;stroke:#1D1D1B;stroke-width:1.5694;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st3{fill:none;stroke:#231F20;stroke-width:6.1956;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}

</style>